import type { IconData } from '@stacksjs/iconify-core'

export const stairs: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M56.473.442S7.152.427 7.168.442c-4.545 0-7.1 2.35-7.1 7.152v49.5c0 4.491 2.297 6.843 6.839 6.843h49.709c4.542 0 6.843-2.234 6.843-6.843v-49.5C63.458 2.91 61.157.442 56.473.442m-1.795 14.996h-8.71v8.828h-8.834v8.953h-8.816v8.906h-8.852v8.981H6.319v-4.528h8.803v-8.96h8.747v-9.02h8.884v-8.853h8.825v-8.794h13.101v4.487z\"/>",
  "width": 63,
  "height": 64,
  "viewBox": "0 0 63 64"
}

export default stairs
